/** Сияние индиго-темы (исходный дизайн) на экранах вне кабинета. В industrial и mono не рисуется. */
export default function PortalGlows() {
  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      <div
        className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full opacity-10"
        style={{ background: 'radial-gradient(circle, #5348e8 0%, transparent 70%)' }}
      />
      <div
        className="absolute bottom-0 right-0 w-[400px] h-[400px] rounded-full opacity-8"
        style={{ background: 'radial-gradient(circle, #5348e8 0%, transparent 70%)' }}
      />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[300px] rounded-full opacity-5"
        style={{ background: 'radial-gradient(ellipse, #5348e8 0%, transparent 70%)' }}
      />
    </div>
  );
}
